//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (searchVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/book/editrawunit/loadscreenview", { searchVO }, successCallback, failureCallback);
    },
    saveRawUnit: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/book/editrawunit/save", vo, successCallback, failureCallback);
    },
    uploadPhoto: (file, id, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "RawUnits");
        formData.append("field", "Photo");
        formData.append("id", id);
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    }
};

export default EditService;